//-----------------product page
   // tabbed content
    $(".tab_content").hide();
    $(".tab_content:first").show();

  /* if in tab mode */
    $("ul.tabs li").click(function() {
		
      $(".tab_content").hide();
      var activeTab = $(this).attr("rel"); 
      $("#"+activeTab).fadeIn();		
		
      $("ul.tabs li").removeClass("active");
      $(this).addClass("active");

	  $(".tab_drawer_heading").removeClass("d_active");
	  $(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");
	  
    });
	/* if in drawer mode */
	$(".tab_drawer_heading").click(function() {
      
      $(".tab_content").hide();
      var d_activeTab = $(this).attr("rel"); 
      $("#"+d_activeTab).fadeIn();
	  
	  $(".tab_drawer_heading").removeClass("d_active");
      $(this).addClass("d_active");
	  
	  $("ul.tabs li").removeClass("active");
	  $("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
    });
	
	
	/* Extra class "tab_last" 
	   to add border to right side
	   of last tab */
	$('ul.tabs li').last().addClass("tab_last");


  $("#Click-here").on('click', function() {
    $(".custom-model-main").addClass('model-open');
  }); 
  $(".close-btn, .bg-overlay").click(function(){
    $(".custom-model-main").removeClass('model-open');
  });

// product tabs
        var iframe = document.createElement('iframe');
        // iframe.src = '//industrialcoatingsltd.com/cdn/shop/files/?v=6974';
        iframe.src = $('.sidebar-products__pdf.datasheet').attr('href');
        iframe.loading = 'lazy';
        iframe.width = '100%';
        iframe.height = '800px';
        iframe.frameborder = '0';
        $(".download_tab").click(function(){
          $(".datasheet_iframe_container").html(iframe);
        });

        var iframe2 = document.createElement('iframe');
        //iframe2.src = '//industrialcoatingsltd.com/cdn/shop/files/?v=6974';
        iframe2.src = $('.sidebar-products__pdf.app_guide').attr('href');
        iframe2.loading = 'lazy';
        iframe2.width = '100%';
        iframe2.height = '800px';
        iframe2.frameborder = '0';
        $(".download_tab2").click(function(){
          $(".datasheet_iframe_container2").html(iframe2);
        });
        
        var iframe3 = document.createElement('iframe');
        // iframe.src = '//industrialcoatingsltd.com/cdn/shop/files/?v=6974';
        iframe3.src = $('.sidebar-products__pdf.addi_info').attr('href');
        iframe3.loading = 'lazy';
        iframe3.width = '100%';
        iframe3.height = '800px';
        iframe3.frameborder = '0';
        $(".download_tab3").click(function(){
          $(".datasheet_iframe_container3").html(iframe3);
        });
        
          function calculateArea() {
            var width = +document.getElementById("width").value;
            var height = +document.getElementById("height").value;
            var coats = +document.getElementById("coats").value;
            var area_covered = +document.getElementById("area_covered").innerHTML;
            var area = width * height * coats;
            var boxes1 = area / area_covered;
            var boxes2 = Math.round(boxes1 * 100) / 100;
            document.getElementById("area").innerHTML = 'You need ' + boxes2 + ' boxes';

          }

          $(document).ready(function() {
              $(".cove_btn, .cove_btn span, .cove_btn img").click(function () {
                  $(".tabs .tab").removeClass("active");
                  $(".tab_last").addClass("active");
                  $("#tab5").css("display","block");
                  $("#tab5").siblings().css("display","none");
              });
          });
